import client from "./client";

export default {
    async loginByHash(credentials) {
        return client.parseResponse(await client.post('/login/' + credentials.uuid, credentials))
    },
    async login(credentials) {
        return client.parseResponse(await client.post('/login', credentials))
    },
    async logout(filters) {
        return client.parseResponse(await client.get('/logout', filters))
    },

    async registerUser(data) {
        return client.parseResponse(await client.post('/register', data))
    },
    async verifyUser(data) {
        return client.parseResponse(await client.post('/verify-account', data))
    },
    async verifyOtp(data) {
        return client.parseResponse(await client.post('/verify-otp/' + data.id, data))
    },
    async sendPhone(data) {
        return client.parseResponse(await client.post('/forgot-password/', data))
    },
    async resendOTP(data) {
        return client.parseResponse(await client.post('/resend-otp/' + data.id, data))
    },
    async activateAccount(data) {
        return client.parseResponse(await client.post('/activate-account/', data))
    },
    async reset(data) {
        return client.parseResponse(await client.post('/reset-password/', data))
    },

    async getUsers(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/users', filters)));
    },
    async createUser(data) {
        return client.parseResponse(await client.post('/users', data))
    },
    async getUser(id) {
        return client.parseResponse(await client.get('/users/' + id));
    },
    async editUser(data) {
        return client.parseResponse(await client.put('/users/' + data.id, data))
    },
    async removeUser(id) {
        return client.parseResponse(await client.delete('/users/' + id))
    },
    async deactivateAdminAccount(data) {
        return client.parseResponse(await client.get('/deactivate/' + data.id))
    },
    async activateAdminAccount(data) {
        return client.parseResponse(await client.get('/activate/' + data.id))
    },

    async getUserRoles(data) {
        return client.parseResponse(await client.get('/user-roles/' + data.id));
    },
    async saveUserRoles(data) {
        return client.parseResponse(await client.post('/roles-users', data));
    },

    async getUserPermissions(data) {
        return client.parseResponse(await client.post('/user-permissions'));
    },

    async exportUsersReport(filters) {
        return client.parseResponse(await client.get('/export-users', filters, {responseType: 'blob'}));
    },
}
